"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newClipboardItem = exports.write = exports.writeText = exports.read = exports.readText = void 0;
function readText() {
    return import('clipboard-polyfill').then((c) => c.readText());
}
exports.readText = readText;
function read() {
    return import('clipboard-polyfill').then((c) => c.read());
}
exports.read = read;
function writeText(data) {
    return import('clipboard-polyfill').then((c) => c.writeText(data));
}
exports.writeText = writeText;
function write(data) {
    return import('clipboard-polyfill').then((c) => c.write(data));
}
exports.write = write;
function newClipboardItem(items, options) {
    return import('clipboard-polyfill').then((c) => new c.ClipboardItem(items, options));
}
exports.newClipboardItem = newClipboardItem;
